module.exports = __webpack_public_path__ + "img/photo-0114.50797a48.jpg";